import React from 'react';
import { useSelector } from 'react-redux';
import Loading from 'components/World/Loading';
import { SCREENS_WITH_UNITY_WORLD } from 'constants/screensWithUnityGlobalLoading';

/**
 * Global loading overlay that renders at the App level.
 * This ensures it appears above ALL other components including
 * SpeechToTextService/LiveKitTextInput which are also at the App level.
 *
 * Only shown when the Unity `World` is mounted (meeting, avatar preview).
 * Other screens (landing, lesson viewer, etc.) must not be covered.
 */
/** Dimmed overlay so the Unity iframe remains visible underneath while loading. */
const OVERLAY_SCRIM = 'rgba(0, 0, 0, 0.55)';

const GlobalLoadingOverlay = () => {
  const worldLoading = useSelector(state => state.world.worldLoading);
  const screen = useSelector(state => state.app.screen);

  if (!SCREENS_WITH_UNITY_WORLD.includes(screen)) return null;

  return <Loading loading={worldLoading} color={OVERLAY_SCRIM} />;
};

export default GlobalLoadingOverlay;
